import { connect } from 'react-redux';
import DailySeancesSeveralCinemasComponent from 'app/components/Seances/DailySeancesSeveralCinemasComponent';
import { getFilteredSeveralCinemasWithDailySeances } from 'app/selectors/DailySeancesSelectors';
import { IReduxState } from 'app/types/state';
import { RouteComponentProps } from 'react-router-dom';

const mapStateToProps = (state: IReduxState, {filterValue}: {filterValue: string}) => ({
	cinemasWithSeances: getFilteredSeveralCinemasWithDailySeances(state, filterValue),
});

export type DailySeancesSeveralCinemasProps = ReturnType<typeof mapStateToProps> & RouteComponentProps;

export default connect(mapStateToProps)(DailySeancesSeveralCinemasComponent);
